// noinspection JSUnusedGlobalSymbols

import {EntityExportAvailableEvent} from './EntityExportAvailableEvent';
import {TeamEventData} from '../resources/TeamEventData';

/**
 * This event can be fired to indicate that some data as requested via the
 * {@link TeamsExportRequested} event is available and can be processed.
 */
export class TeamsExportAvailable extends EntityExportAvailableEvent<TeamEventData> {}
